module.exports = __webpack_public_path__ + "img/@logo_kto@3x.40fe4baf.png";